import * as api from "@/entities/bot-builder"
import { draftCache as cache } from "@/entities/bot-builder"
import type { ActionsContext } from "./types"

export function createEntryLinkActions({ enqueue, scenarioId }: ActionsContext) {
	return {
		createEntryLink: (input: api.EntryLinkInput) =>
			enqueue(
				"Не удалось создать метку",
				(baseRevision) => api.createEntryLink(scenarioId, { ...input, baseRevision }),
				(draft, result) => cache.upsertEntryLink(draft, result.entryLink),
			),

		updateEntryLink: (linkId: string, patch: Partial<api.EntryLinkInput>) =>
			enqueue(
				"Не удалось сохранить метку",
				(baseRevision) => api.updateEntryLink(scenarioId, linkId, { ...patch, baseRevision }),
				(draft, result) => cache.upsertEntryLink(draft, result.entryLink),
			),

		deleteEntryLink: (linkId: string) =>
			enqueue(
				"Не удалось удалить метку",
				(baseRevision) => api.deleteEntryLink(scenarioId, linkId, baseRevision),
				(draft) => cache.removeEntryLink(draft, linkId),
			),
	}
}
